import { render } from "./AllBlogs.vue?vue&type=template&id=53be2bed&scoped=true"
import script from "./AllBlogs.vue?vue&type=script&lang=js"
export * from "./AllBlogs.vue?vue&type=script&lang=js"

import "./AllBlogs.vue?vue&type=style&index=0&id=53be2bed&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ic-lab/ic-lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53be2bed"]])

export default __exports__